import { useQuery } from "@tanstack/react-query";
import { listApplicationProcessesOpenForEnrolment } from "../openapi/api-client.ts";

export const useListApplicationProcessesOpenForEnrolment = () =>
  useQuery({
    queryKey: ["listApplicationProcessesOpenForEnrolment"],
    queryFn: async () => {
      const response =
        await listApplicationProcessesOpenForEnrolment(undefined);

      if (!response.data) {
        throw new Error("no data given");
      }

      return response.data;
    },
  });
